export default "__VITE_ASSET__DiNGGsWJ__"